import { createAction } from "@reduxjs/toolkit";
import { OrderEntity, OrderMissionEntity } from "@src/features/order/entities";

export const setSelectedHistoryOrder = createAction<
  OrderEntity | OrderMissionEntity | null
>("history/setSelectedOrder");
